module.exports = __webpack_public_path__ + "media/images/home/document@2x-d7f449e1f507914474700399ea8314f9.png";